export class FailedToGetReportAccessTokenError {

};
